// import { useTranslationContext } from "@providers/TranslationProvider";
import Banner from "@components/Banner";
import Breadcrumbs from "@components/Breadcrumbs";
import Experiences from "@components/Dinning/Experiences";
import FeaturedItem from "@components/Dinning/FeaturedItems/FeaturedItem";
import FeaturedItems from "@components/Dinning/FeaturedItems/FeaturedItems";
import Intro from "@components/Dinning/Intro";
import RestaurantInfo from "@components/Dinning/RestaurantInfo";
import Footer from "@components/Footer";
import Header from "@components/Header";
import StayInspired from "@components/Home/StayInspired";
import { usePageContext } from "@providers/PageProvider";
import { useRouteContext } from "@providers/RouteProvider";
import helper from "@utils/helper";
import styles from "./Dinning.module.scss";
import _ from "lodash";

const View = () => {
  const { router } = useRouteContext();
  const { pageData, hotel } = usePageContext();
  const banner = helper.formatBanner(pageData);
  const footer = helper.renderDetailsFooter(hotel);
  return (
    <div className="bg-black" data-scroll-container>
      <Header />
      <Banner
        image={_.get(banner, "image")}
        scale={1.1}
        title={_.get(banner, "title", "")}
        labelProps={{ className: styles.label }}
      />
      <Breadcrumbs data={router.breadcrumbs("dinning", { hotel })} />
      <Intro />
      <FeaturedItems />
      <RestaurantInfo />
      <FeaturedItem />
      <Experiences />
      <StayInspired />
      <Footer
        data={{
          name: footer.name,
          address: footer.address,
          email: footer.email,
        }}
      />
    </div>
  );
};

export default View;
